import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dataForm" }
const _hoisted_2 = { class: "form-title" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "underlineForm"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "dialog-footer mt-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FromField = _resolveComponent("FromField")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "front"),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fromFieldData, (item, index) => {
      return (_openBlock(), _createBlock(_component_el_form, {
        class: "mb-20",
        ref_for: true,
        ref: el => _ctx.dataForm[index] = el,
        model: item,
        "label-position": "top",
        "label-width": "100px",
        key: index,
        disabled: _ctx.formDisabled
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
              class: _normalizeClass(["label", item.labelClass])
            }, _toDisplayString(item.labelName), 3),
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.title), 1),
            (item.type === 2 && !item.formList.length && _ctx.canAdd)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.handleAdd(item)),
                  class: "add-icon add-title cursor"
                }, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "iconfont icon-tubiao-25" }, null, -1)
                ]))], 8, _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          (item.type === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.formList, (fields, k) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                    (_ctx.handleVisible(fields, item.formList))
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          class: _normalizeClass([fields.componentType, { fullWidth: fields.config.width }, { redBorder: fields.config.colorTheme === 1 }, { greenBorder: fields.config.colorTheme === 2 }]),
                          error: fields.rules[0].message,
                          rules: fields.rules,
                          prop: 'formList.' + k + '.value',
                          label: fields.fieldName
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FromField, {
                              fields: fields,
                              onFormChange: ($event: any) => (_ctx.handleChange(fields, item.formList)),
                              id: _ctx.id
                            }, null, 8, ["fields", "onFormChange", "id"])
                          ]),
                          _: 2
                        }, 1032, ["class", "error", "rules", "prop", "label"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (item.type === 2)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.formList, (j, k) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: k,
                  class: "border-container"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(j.list, (fields, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                      (_ctx.handleVisible(fields, j.list))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            class: _normalizeClass([fields.componentType, { fullWidth: fields.config.width }, { redBorder: fields.config.colorTheme === 1 }, { greenBorder: fields.config.colorTheme === 2 }]),
                            rules: fields.rules,
                            prop: 'formList.' + k + '.list.' + i + '.value',
                            label: fields.fieldName,
                            error: fields.rules[0].message
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_FromField, {
                                fields: fields,
                                onFormChange: ($event: any) => (_ctx.handleChange(fields, j.list)),
                                id: _ctx.id
                              }, null, 8, ["fields", "onFormChange", "id"])
                            ]),
                            _: 2
                          }, 1032, ["class", "rules", "prop", "label", "error"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  (_ctx.canAdd)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.handleDelete(item.formList, k)),
                        class: "delete-icon"
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (k === item.formList.length - 1 && _ctx.canAdd)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.handleAdd(item)),
                        class: "add-icon cursor add-list"
                      }, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("i", { class: "iconfont icon-tubiao-25" }, null, -1)
                      ]))], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["model", "disabled"]))
    }), 128)),
    (_ctx.conractMarketUserList.length)
      ? (_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: _ctx.conractMarketUserList,
          border: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "姓名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "rate",
              label: "比例(单位%)"
            })
          ]),
          _: 1
        }, 8, ["data"]))
      : _createCommentVNode("", true),
    (_ctx.isShowCloseBtn || _ctx.isShowSubmitBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.isShowCloseBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: _ctx.cancle,
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('table.cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isShowSubmitBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                loading: _ctx.submitLoading,
                onClick: _ctx.handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('table.confirm')), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}